import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function SEOLandingTemplate({ 
  title, 
  metaTitle,
  metaDescription,
  h1,
  sub,
  keywords,
  features,
  faqs,
  ctaLink,
  ctaText
}) {
  useEffect(() => { if (metaTitle) document.title = metaTitle; }, [metaTitle]);
  return (
    <div className="fade-up" style={{ background: 'white', minHeight: '100vh' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 24px' }}>
        <div style={{ textAlign: 'center', maxWidth: 800, margin: '0 auto 40px' }}>
          <div style={{ display: 'inline-flex', background: '#F3F4F6', border: '1px solid #E5E7EB', color: '#37474F', fontSize: 11, fontWeight: 600, padding: '4px 12px', borderRadius: 99, marginBottom: 16, letterSpacing: '0.05em' }}>FREE TOOL • PROFESSIONAL GRADE</div>
          <h1 style={{ fontSize: 44, fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: 16, color: '#111' }}>{h1}</h1>
          <p style={{ fontSize: 17, color: '#6B7280', lineHeight: 1.6, marginBottom: 24 }}>{sub}</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to={ctaLink} className="btn btn-lg" style={{ background: '#FF642D', color: 'white', height: 46, padding: '0 24px', fontSize: 14, fontWeight: 600 }}>{ctaText}</Link>
            <Link to="/pricing" className="btn btn-lg btn-white" style={{ height: 46, fontSize: 14 }}>View Pricing</Link>
          </div>
          <div style={{ marginTop: 16, fontSize: 12, color: '#9CA3AF' }}>No credit card required • 15 free credits • Professional data</div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, marginBottom: 48 }}>
          {features.map((f,i) => (
            <div key={i} className="card" style={{ margin: 0, textAlign: 'center', borderColor: '#F3F4F6' }}>
              <div style={{ fontSize: 22, marginBottom: 10 }}>{f.icon}</div>
              <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, color: '#111' }}>{f.title}</div>
              <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.5 }}>{f.desc}</div>
            </div>
          ))}
        </div>

        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 20, textAlign: 'center', color: '#111' }}>How It Works</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 48 }}>
            {[
              { step: '1', title: 'Enter Your Target', desc: 'Provide your domain, keyword, or URL for analysis' },
              { step: '2', title: 'Analyze Data', desc: 'Get comprehensive insights from our professional data sources' },
              { step: '3', title: 'Optimize Performance', desc: 'Apply data-driven recommendations to improve rankings' },
            ].map(s => (
              <div key={s.step} style={{ textAlign: 'center', padding: 20, background: '#FAFBFC', borderRadius: 10, border: '1px solid #F3F4F6' }}>
                <div style={{ width: 32, height: 32, background: '#111', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, margin: '0 auto 12px', fontSize: 14 }}>{s.step}</div>
                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6, color: '#111' }}>{s.title}</div>
                <div style={{ fontSize: 12, color: '#6B7280', lineHeight: 1.5 }}>{s.desc}</div>
              </div>
            ))}
          </div>

          <div style={{ background: '#FAFBFC', border: '1px solid #E5E7EB', borderRadius: 12, padding: 28, marginBottom: 32 }}>
            <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20, color: '#111' }}>Frequently Asked Questions</h2>
            {faqs.map((faq,i) => (
              <div key={i} style={{ marginBottom: 16, paddingBottom: 16, borderBottom: i < faqs.length-1 ? '1px solid #E5E7EB' : 'none' }}>
                <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, color: '#111' }}>{faq.q}</div>
                <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.6 }}>{faq.a}</div>
              </div>
            ))}
          </div>

          <div style={{ background: '#111', color: 'white', borderRadius: 12, padding: 28, textAlign: 'center' }}>
            <div style={{ fontWeight: 800, fontSize: 20, marginBottom: 8 }}>Ready to get started?</div>
            <div style={{ fontSize: 13, color: '#9CA3AF', marginBottom: 20 }}>Professional tools • Free trial • No credit card required</div>
            <Link to={ctaLink} className="btn" style={{ background: '#FF642D', color: 'white', fontWeight: 600 }}>{ctaText}</Link>
          </div>

          <div style={{ marginTop: 32, padding: '20px 0', borderTop: '1px solid #F3F4F6', textAlign: 'center' }}>
            <p style={{ fontSize: 12, color: '#9CA3AF', lineHeight: 1.6 }}>Professional SEO toolkit providing accurate data for marketers, agencies, and businesses worldwide.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
